import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import Logo from "../../images/logo.png";
import ptImg1 from "../../images/shap/wave-blue.png";
import ptImg2 from "../../images/shap/circle-dots.png";
import ptImg3 from "../../images/shap/plus-blue.png";

import {
  IconLinkedin,
  IconInstagram,
  IconWhatsapp,
  IconPhone,
  IconMail,
  IconMapPin,
  IconClock,
} from "../../components/Icons";
import { brandList } from "../../redux/slice/medicineSlice";

const Footer = () => {
  const dispatch = useDispatch();
  const brands = useSelector(
    (state) => state?.medicine?.brands?.brands || []
  );

  useEffect(() => {
    if (!brands || brands.length === 0) {
      dispatch(brandList({}));
    }
  }, [dispatch, brands]);

  const socialIcon = (label, href, Icon) => (
    <li key={label}>
      <a
        target="_blank"
        rel="noopener noreferrer"
        href={href}
        aria-label={label}
        style={{
          width: 40, height: 40,
          display: "inline-flex", alignItems: "center", justifyContent: "center",
          borderRadius: 12,
          border: "1px solid var(--ink-200)",
          background: "var(--surface)",
          color: "var(--brand-primary)",
        }}
      >
        <Icon width="18" height="18" />
      </a>
    </li>
  );

  return (
    <footer className="footer overflow-hidden">
      <div className="footer-top">
        <div className="container">
          <div className="row g-4">
            {/* Brand */}
            <div className="col-xl-4 col-lg-4 col-md-6">
              <div className="widget widget_info">
                <div className="footer-logo mb-3">
                  <Link to="/">
                    <img src={Logo} alt="Clametis Pharma" width="160" height="45" />
                  </Link>
                </div>
                <div className="ft-contact">
                  <p>
                    Clametis Pharma manufactures and distributes cardiology-focused
                    generic medicines across India. Batch-traceable quality.
                    Distributor-first partnerships.
                  </p>
                  <div className="footer-social-link mt-3">
                    <ul className="d-flex gap-2 list-unstyled mb-0">
                      {socialIcon("Clametis on LinkedIn", "https://www.linkedin.com/in/clametis-pharma-530394348/", IconLinkedin)}
                      {socialIcon("Clametis on Instagram", "https://www.instagram.com/tholiyaamit/", IconInstagram)}
                      {socialIcon("Chat with Clametis on WhatsApp", "https://wa.me/917698727472", IconWhatsapp)}
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            {/* Quick Links */}
            <div className="col-xl-3 col-lg-3 col-6">
              <div className="widget footer_widget">
                <h3 className="footer-title">Company</h3>
                <ul>
                  <li><Link to="/"><span>Home</span></Link></li>
                  <li><Link to="/about-us"><span>About us</span></Link></li>
                  <li><Link to="/quality"><span>Quality</span></Link></li>
                  <li><Link to="/therapeutic-areas"><span>Therapeutic areas</span></Link></li>
                  <li><Link to="/distribution"><span>Distributors</span></Link></li>
                  <li><Link to="/become-a-distributor"><span>Become a distributor</span></Link></li>
                  <li><Link to="/blogs"><span>Blog</span></Link></li>
                  <li><Link to="/faq"><span>FAQ</span></Link></li>
                </ul>
              </div>
            </div>

            {/* Brands */}
            <div className="col-xl-2 col-lg-2 col-6">
              <div className="widget footer_widget">
                <h3 className="footer-title">Brands</h3>
                <ul>
                  {brands && brands.length > 0 ? (
                    brands.slice(0, 8).map((item) => (
                      <li key={item?.id}>
                        <Link to="/medicine">
                          <span>{item?.name}</span>
                        </Link>
                      </li>
                    ))
                  ) : (
                    <li>
                      <Link to="/medicine">
                        <span>View all medicines</span>
                      </Link>
                    </li>
                  )}
                  {brands && brands.length > 0 && (
                    <li>
                      <Link to="/medicine" className="footer-view-all">
                        <span>View all →</span>
                      </Link>
                    </li>
                  )}
                </ul>
              </div>
            </div>

            {/* Contact */}
            <div className="col-xl-3 col-lg-3 col-md-6">
              <div className="widget widget_form">
                <h3 className="footer-title">Contact us</h3>
                <div className="mb-30 d-flex flex-column gap-3">
                  <div className="d-flex align-items-start foot-contact">
                    <span><IconPhone width="16" height="16" /></span>
                    <a href="tel:+917698727472" className="fw-medium">
                      +91 76987 27472
                    </a>
                  </div>
                  <div className="d-flex align-items-start foot-contact">
                    <span><IconMail width="16" height="16" /></span>
                    <a href="mailto:info@clametis.com" className="fw-medium">
                      info@clametis.com
                    </a>
                  </div>
                  <div className="d-flex align-items-start foot-contact">
                    <span><IconMapPin width="16" height="16" /></span>
                    <a
                      href="https://maps.app.goo.gl/fj5BHqZNrS96dNAD9"
                      className="fw-medium"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      D-413, Titanium City Center, Anand Nagar Road,
                      Satellite, Ahmedabad — 380015
                    </a>
                  </div>
                  <div className="d-flex align-items-start foot-contact">
                    <span><IconClock width="16" height="16" /></span>
                    <span className="fw-medium">Mon–Sat · 9:30 – 18:30 IST</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="footer-bottom">
          <div className="row">
            <div className="col-12 text-center">
              <div className="d-flex align-items-center justify-content-between gap-3 flex-wrap">
                <p className="copyright-text mb-0">
                  © {new Date().getFullYear()} Clametis Pharma. Designed &amp; developed by{" "}
                  <a
                    href="https://dcpltechnology.com/"
                    rel="noopener noreferrer"
                    target="_blank"
                    className="text-secondary"
                  >
                    DCPL Technology Pvt. Ltd.
                  </a>
                </p>

                <ul className="d-flex align-items-center gap-3 mb-0 custom-links list-unstyled">
                  <li>
                    <Link to="/privacy-policy">
                      <span>Privacy policy</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/terms-of-use">
                      <span>Terms of use</span>
                    </Link>
                  </li>
                  <li>
                    <a href="/sitemap.xml">
                      <span>Sitemap</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <img className="pt-img1 animate-wave" src={ptImg1} alt="" aria-hidden="true" />
      <img className="pt-img2 animate1" src={ptImg2} alt="" aria-hidden="true" />
      <img className="pt-img3 animate-rotate" src={ptImg3} alt="" aria-hidden="true" />
    </footer>
  );
};

export default Footer;
